import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { TeacherRateList } from "../components/TeacherRateList";
import { TeacherRateForm } from "../components/TeacherRateForm";
import { ProfileTypesModal } from "../components/ProfileTypesModal";

function TarifasPage() {
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showProfileTypes, setShowProfileTypes] = useState(false);

  const openNew = () => {
    setEditing(null);
    setShowForm(true);
  };

  const openEdit = (rate) => {
    setEditing(rate);
    setShowForm(true);
  };

  const handleHide = () => {
    setShowForm(false);
    setEditing(null);
  };

  return (
    <Container fluid className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h4 className="mb-0">Docentes y tarifas</h4>
        <div className="d-flex gap-2 flex-wrap">
          <Button
            variant="outline-secondary"
            onClick={() => setShowProfileTypes(true)}
            style={{ minHeight: 44 }}
          >
            Tipos de perfil
          </Button>
          <Button
            variant="primary"
            onClick={openNew}
            style={{ minHeight: 44 }}
          >
            + Nueva tarifa
          </Button>
        </div>
      </div>
      <p className="text-muted mb-3">
        Historial de tarifas por docente ordenado por fecha de vigencia. Cada
        cambio de tarifa se registra sin modificar el historial anterior.
      </p>

      <TeacherRateList onEdit={openEdit} />

      <TeacherRateForm
        show={showForm}
        onHide={handleHide}
        editing={editing}
      />

      <ProfileTypesModal
        show={showProfileTypes}
        onHide={() => setShowProfileTypes(false)}
      />
    </Container>
  );
}

export { TarifasPage };
